var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import styled, { css, } from 'styled-components';
import { compose, layout, margin, typography, } from 'styled-system';
import { muiChevronDown } from '@ally/metronome-icons';
import { MuiIcon } from '../Icon';
import { ErrorNotification } from '../ErrorNotification';
import whisper from '../whisper';
import { get, tabletOnly, propsToForward } from '../tools/utils';
var flatten = require('lodash.flatten');
var SingleOption = function (_a) {
    var option = _a.option, isPlaceholder = _a.isPlaceholder;
    var placeholderDefaults = {
        defaultValue: undefined,
    };
    return (React.createElement("option", __assign({ key: option.id, value: option.value, disabled: option.disabled }, (isPlaceholder && placeholderDefaults)), option.label));
};
var PlaceholderOption = function (_a) {
    var placeholder = _a.placeholder;
    if (placeholder) {
        return (React.createElement(SingleOption, { option: {
                id: 'placeholder',
                value: '',
                label: placeholder,
            }, isPlaceholder: true }));
    }
    return null;
};
var toOption = function (option, optionId, labelKey, valueKey) {
    return {
        label: option[labelKey],
        value: option[valueKey],
        id: optionId,
        type: 'option',
        disabled: option.disabled,
    };
};
var getParsedOptions = function (options, labelKey, valueKey) {
    return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
            /* Group */
            var children = item.options.map(function (option, i) {
                return toOption(option, itemIndex + "-" + i, labelKey, valueKey);
            });
            if (children.length) {
                return __spreadArrays(acc, [
                    {
                        type: 'group',
                        options: children,
                        label: item.label,
                        groupId: itemIndex,
                    },
                ]);
            }
        }
        var option = toOption(item, "" + itemIndex, labelKey, valueKey);
        return __spreadArrays(acc, [option]);
    }, []);
};
var OptionGroup = function (_a) {
    var option = _a.option;
    if (option.type === 'group') {
        return (React.createElement("optgroup", { label: option.label, "data-testid": option.label }, option.options &&
            option.options.map(function (o) { return (React.createElement(SingleOption, { option: o, key: o.label })); })));
    }
    return React.createElement(SingleOption, { option: option });
};
var Options = function (_a) {
    var options = _a.options, labelKey = _a.labelKey, valueKey = _a.valueKey;
    var parsedOptions = getParsedOptions(options, labelKey, valueKey);
    return (React.createElement(React.Fragment, null, parsedOptions.map(function (option) {
        return React.createElement(OptionGroup, { option: option, key: option.label });
    })));
};
var mapOptionsGroup = function (option) {
    var safeOpts = option.options || [];
    return safeOpts.map(function (opt) { return opt.value; });
};
var gatherValues = function (options) {
    var vals = options.map(function (option) {
        var isUndef = option.value === undefined;
        if (!isUndef) {
            return option.value;
        }
        return mapOptionsGroup(option);
    });
    return flatten(vals);
};
var errorStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), get.colors('error'));
var SelectContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  vertical-align: top;\n\n  ::before {\n    content: ' ';\n    display: block;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    right: 36px;\n    width: 1px;\n    background-color: ", ";\n    pointer-events: all;\n  }\n"], ["\n  width: 100%;\n  max-width: 100%;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  vertical-align: top;\n\n  ::before {\n    content: ' ';\n    display: block;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    right: 36px;\n    width: 1px;\n    background-color: ", ";\n    pointer-events: all;\n  }\n"])), get.colors('slate-3'));
var getFill = function (props) {
    return props.disabled
        ? get.colors('slate-3')(props)
        : get.colors('bluesuedeshoes')(props);
};
var SelectIcon = styled(MuiIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  z-index: 1;\n  margin-top: -8px;\n  right: 11px;\n  position: absolute;\n  display: block;\n  top: 55%;\n  pointer-events: none;\n  path {\n    fill: ", ";\n  }\n"], ["\n  z-index: 1;\n  margin-top: -8px;\n  right: 11px;\n  position: absolute;\n  display: block;\n  top: 55%;\n  pointer-events: none;\n  path {\n    fill: ", ";\n  }\n"])), getFill);
var StyledSelect = styled.select.withConfig({
    shouldForwardProp: propsToForward,
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  width: 100%;\n  max-width: 100%;\n  appearance: none;\n  box-shadow: none;\n  border-radius: 0;\n  padding-left: 10px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-right: 2.5em;\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  line-height: 1.5;\n  vertical-align: top;\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  &[disabled] {\n    background-color: ", ";\n    cursor: not-allowed;\n    color: ", ";\n    ::after {\n      color: ", ";\n    }\n  }\n  &::-ms-expand {\n    display: none;\n  }\n  ", "\n"], ["\n  ", "\n  width: 100%;\n  max-width: 100%;\n  appearance: none;\n  box-shadow: none;\n  border-radius: 0;\n  padding-left: 10px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-right: 2.5em;\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  line-height: 1.5;\n  vertical-align: top;\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  &[disabled] {\n    background-color: ", ";\n    cursor: not-allowed;\n    color: ", ";\n    ::after {\n      color: ", ";\n    }\n  }\n  &::-ms-expand {\n    display: none;\n  }\n  ",
    "\n"])), compose(layout, typography), get.colors('white'), get.colors('slate-3'), get.colors('slate-5'), get.colors('slate-1'), get.colors('slate-3'), get.colors('slate-3'), function (props) {
    return props.error ? errorStyles : '';
});
var Select = React.forwardRef(function (_a, ref) {
    var options = _a.options, id = _a.id, name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, error = _a.error, placeholder = _a.placeholder, _d = _a.labelKey, labelKey = _d === void 0 ? 'label' : _d, _e = _a.valueKey, valueKey = _e === void 0 ? 'value' : _e, 
    /**
     * required is used to enable browser validation. If you are using this
     * component with useForm, you do not need this.
     */
    _f = _a.required, 
    /**
     * required is used to enable browser validation. If you are using this
     * component with useForm, you do not need this.
     */
    required = _f === void 0 ? false : _f, 
    /**
     * Browsers without HTML5 support still need ariaRequired -
     * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-required_attribute
     */
    _g = _a.ariaRequired, 
    /**
     * Browsers without HTML5 support still need ariaRequired -
     * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-required_attribute
     */
    ariaRequired = _g === void 0 ? false : _g, _h = _a.ariaLabelledby, ariaLabelledby = _h === void 0 ? '' : _h, _j = _a.ariaDescribedby, ariaDescribedby = _j === void 0 ? '' : _j, _k = _a.ariaLabel, ariaLabel = _k === void 0 ? '' : _k, value = _a.value, rest = __rest(_a, ["options", "id", "name", "className", "disabled", "error", "placeholder", "labelKey", "valueKey", "required", "ariaRequired", "ariaLabelledby", "ariaDescribedby", "ariaLabel", "value"]);
    var allValues = gatherValues(options);
    var isValueValid = allValues.includes(value) || value === '';
    // NOTE: users should sanitize values before they are passed to the select.
    // If the consumer supplies a `value` prop that does not correspond to
    // either a supplied option value or an empty string, then the select
    // value will be set to undefined and the following message will be
    // displayed in the console.
    if (!isValueValid) {
        whisper.info({
            message: "\"" + value + "\" does not correspond to one of the\n    option values. Setting value to undefined",
        });
    }
    var safeValue = isValueValid ? value : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectContainer, { error: error, disabled: disabled, className: className },
            React.createElement(SelectIcon, { muiIcon: muiChevronDown, size: "sm", disabled: disabled }),
            React.createElement(StyledSelect, __assign({ ref: ref, id: id, name: name || id, disabled: disabled, required: required, error: error, value: safeValue, height: tabletOnly('45px', '34px'), fontSize: tabletOnly(2, 1) }, (ariaRequired && { 'aria-required': ariaRequired }), (ariaDescribedby && { 'aria-describedby': ariaDescribedby }), (ariaLabel && { 'aria-label': ariaLabel }), (ariaLabelledby && { 'aria-labelledby': ariaLabelledby }), (error && {
                'aria-describedby': id + "Error",
                'data-allytm-error': error,
            }), rest),
                React.createElement(PlaceholderOption, { placeholder: placeholder }),
                React.createElement(Options, { options: options, labelKey: labelKey, valueKey: valueKey }))),
        error && React.createElement(ErrorNotification, { id: id + "Error", errorMessage: error })));
});
var SelectWithMarginProps = styled(Select)(margin);
export { SelectWithMarginProps as Select, Select as SelectForProps };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Select.js.map